'use client';

import React from 'react';
import { classnames } from 'helpers/utils/classnames';
import Cell from './components/cell';
import Grid from './components/grid';
import TasticWrapper from './components/tastic-wrapper';
import { RendererProps } from './types';
import { highlight } from './utils/highlight';

const Renderer = ({
  data: pageData,
  params,
  searchParams,
  currentHighlight,
  gridClassName = '',
  wrapperClassName = '',
  categories = [],
}: RendererProps) => {
  const { page, data } = pageData;

  const headSection = page.sections.head;
  const mainSection = page.sections.main;
  const footerSection = page.sections.footer;

  const sectionsClassNames = {
    head: '',
    main: 'grow body-section',
    footer: '',
  } as Record<string, string>;

  const renderGridSection = (section: any, sectionKey: 'head' | 'main' | 'footer') => {
    if (!section) return null;

    return (
      <Grid
        key={section?.sectionId}
        gridClassName={`${gridClassName} h-full`}
        wrapperClassName={classnames(
          'relative w-full',
          wrapperClassName,
          highlight(currentHighlight === section?.sectionId),
          sectionsClassNames[sectionKey],
        )}
      >
        {section?.layoutElements?.map((layoutElement: any) => (
          <Cell
            key={layoutElement.layoutElementId}
            configuration={layoutElement.configuration}
            isHighlighted={currentHighlight === layoutElement.layoutElementId}
          >
            {layoutElement.tastics.map((tastic: any) => (
              <TasticWrapper
                key={tastic.tasticId}
                data={tastic}
                params={params}
                searchParams={searchParams}
                dataSources={data.dataSources}
                isHighlighted={currentHighlight === tastic.tasticId}
                categories={categories}
              />
            ))}
          </Cell>
        ))}
      </Grid>
    );
  };

  return (
    <div className="flex size-full flex-col items-stretch justify-start">
      {headSection && <>{renderGridSection(headSection, 'head')}</>}

      {mainSection && (
        <main id="main-content" tabIndex={-1} className="flex w-full grow flex-col">
          {renderGridSection(mainSection, 'main')}
        </main>
      )}

      {footerSection && <>{renderGridSection(footerSection, 'footer')}</>}
    </div>
  );
};

export default Renderer;
